/**
 * PartnerProductsCtrl controller
 */
/**
 * PartnerProductsCtrl controller
 *
 * @class PartnerProductsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:PartnerProductsCtrl
 */
/* @ngInject */
export default function PartnerProductsCtrl ($scope, $location, PartnerProduct, PartnerProgram, pckg, authSvc) {
  var vm = this

  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Network
   *
   * @memberof mwApp/packages.controller:PartnerProductsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  const networkId = vm.pckg.id

  /**
   * Get Vod Sets from backend
   *
   * @memberof mwApp/packages.controller:ContentSetsCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getPartnerProducts = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    PartnerProduct.loadSmart(tableState, { networkId })
      .then(
        data => {
          vm.partnerProducts = data.content.map(c => (new PartnerProduct({ ...c, networkId })))
          vm.issFound = !!vm.partnerProducts.length
          vm.tableState = tableState
          $scope.loading = false
        }
      )
  }

  PartnerProgram.loadAll().then((res) => {
    vm.partnerPrograms = res
    // Deep-link from elsewhere (e.g. a created product) → open the editor page.
    if (window.localStorage.getItem('partnerProductId')) {
      const id = window.localStorage.getItem('partnerProductId')
      window.localStorage.removeItem('partnerProductId')
      $location.url(`organizations/${networkId}/partner-products/${id}`)
    }
  })

  /**
   * Delete Partner Program
   *
   * @memberof mwApp/partnerProducts.controller:PartnerProductsCtrl
   */
  vm.delete = function (product) {
    product._delete()
      .then(() => vm.getPartnerProducts(vm.tableState))
  }
}
